/* =========================================================
   WRAPPER
   ========================================================= */

.custom-scrollbar-wrapper {
    position: relative;

    box-sizing: border-box;

    width: 100%;
    min-width: 0;

    overflow: hidden;
}


/* =========================================================
   SCROLL CONTENT
   ========================================================= */

.custom-scrollbar {
    box-sizing: border-box;

    width: 100%;
    height: 100%;

    min-width: 0;
    min-height: 0;

    overscroll-behavior: contain;

    -webkit-overflow-scrolling: touch;

    /*
     * Firefox:
     * hide native scrollbar
     */
    scrollbar-width: none;
}


/* =========================================================
   DIRECTION
   ========================================================= */

.custom-scrollbar--vertical {
    overflow-y: auto;
    overflow-x: hidden;
}

.custom-scrollbar--horizontal {
    overflow-x: auto;
    overflow-y: hidden;

    /*
     * Contain only sideways scrolling: with `contain` on both axes the
     * mouse wheel over a wide table never reaches the page or panel
     * scrolling around it.
     */
    overscroll-behavior-y: auto;
}

.custom-scrollbar--both {
    overflow: auto;
}


/* =========================================================
   HIDE NATIVE CHROME / EDGE / SAFARI SCROLLBAR
   ========================================================= */

.custom-scrollbar::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}


/* =========================================================
   OUR CUSTOM THUMB
   ========================================================= */

.custom-scrollbar-thumb {
    position: absolute;

    z-index: 10;

    border-radius: 999px;

    background: rgba(120, 128, 140, 0.58);

    pointer-events: none;

    transition:
        opacity 280ms ease-in-out,
        background-color 180ms ease;

    will-change: opacity, transform;
}


/* Vertical */

.custom-scrollbar-thumb--vertical {
    width: 4px;

    right: 2px;
}


/* Horizontal */

.custom-scrollbar-thumb--horizontal {
    height: 4px;

    bottom: 2px;
}


/* =========================================================
   DISABLED
   ========================================================= */

.custom-scrollbar--disabled {
    overflow: visible !important;

    height: auto !important;

    max-height: none !important;
}


/* =========================================================
   RTL
   ========================================================= */

[dir="rtl"]
.custom-scrollbar-thumb--vertical {
    right: auto;
    left: 2px;
}
